import { useState } from 'react';
import { FaMagnifyingGlass } from 'react-icons/fa6';

import { getIssuesByWorkOrderReport, getWorkOrderIssuesDetails } from '../services/ReportsService';
import { exportIssuesByWorkOrderReport, exportWorkOrderDetailsReport } from '../services/ExportService';
import TableContainer from '../components/table/TableContainer';
import { formatCurrency } from '../utils/numbers';
import { AddButton, TableActionButton } from '../styles/StyledComponents';

const ReportIssueValueByWorkOrder = () => {
    // ----- State
    const [updateTable, setUpdateTable] = useState(false);
    let [showWorkOrderDetailsTable, setShowWorkOrderDetailsTable] = useState(false);
    let [currentWorkOrder, setCurrentWorkOrder] = useState({});
    let [parentFilters, setParentFilters] = useState([]);

    // ----- Actions
    const handleShowWorkOrderDetails = (workOrderId, orderNumber) => {
        setShowWorkOrderDetailsTable(false);

        setTimeout(() => {
            setCurrentWorkOrder({ workOrderId, orderNumber });
            setUpdateTable(!updateTable);
            setShowWorkOrderDetailsTable(true);
        }, 100);
    };

    const handleDataAfterFiltering = (filters) => {
        // Filtrar y mapear filtros relevantes para los detalles
        let parentFilters = JSON.parse(JSON.stringify(filters));
        parentFilters = parentFilters
            .filter((pf) => pf.columnName === 'article' || pf.columnName === 'eventDate')
            .map((f) => {
                if (f.columnName === 'article') {
                    f.columnName = 'name'; // En detalles se llama 'name'
                }
                return f;
            });
        setParentFilters(parentFilters);

        setShowWorkOrderDetailsTable(false);
    };

    // ----- Constants
    const Actions = ({ row }) => (
        <div className='d-flex'>
            <TableActionButton className='btn btn-primary' onClick={() => handleShowWorkOrderDetails(row.id, row.orderNumber)}>
                <FaMagnifyingGlass />
                Ver Detalles
            </TableActionButton>
        </div>
    );

    const columns = [
        {
            name: 'Orden de Trabajo',
            selector: (row) => row.orderNumber,
            sortable: true,
            sortField: 'orderNumber',
        },
        {
            name: 'Valor Total de Despachos',
            selector: (row) => `₡${formatCurrency(row.totalValue)}`,
            sortable: true,
            sortField: 'totalValue',
        },
        {
            name: 'Acciones',
            width: '150px',
            cell: (row) => <Actions row={row} />,
        },
    ];

    const filters = [
        {
            column: 'orderNumber',
            input: 'text',
            label: 'Número de Orden',
            operation: 'like',
            length: 20,
        },
        {
            column: 'article',
            input: 'text',
            label: 'Artículo',
            operation: 'like',
            length: 50,
        },
        {
            column: 'totalValue',
            input: 'range',
            label: 'Valor Total',
            operation: 'between',
        },
        {
            column: 'eventDate',
            input: 'dates',
            label: 'Fecha de Despacho',
            operation: 'between',
        },
    ];

    const exportOptions = {
        handler: exportIssuesByWorkOrderReport,
    };

    const exportDetailsOptions = {
        handler: exportWorkOrderDetailsReport,
    };

    const workOrderDetailsTableColumns = [
        {
            name: 'Artículo',
            selector: (row) => row.name,
            sortable: true,
            sortField: 'name',
        },
        {
            name: 'Cantidad',
            selector: (row) => row.amount,
            sortable: true,
            sortField: 'amount',
        },
        {
            name: 'Valor promedio',
            selector: (row) => `₡${formatCurrency(row.averageValue)}`,
            sortable: true,
            sortField: 'averageValue',
        },
        {
            name: 'Valor total',
            selector: (row) => `₡${formatCurrency(row.totalValue)}`,
            sortable: true,
            sortField: 'totalValue',
        },
    ];

    const workOrderDetailsTableFilters = [
        {
            column: 'name',
            input: 'text',
            label: 'Artículo',
            operation: 'like',
            length: 50,
        },
        {
            column: 'amount',
            input: 'range',
            label: 'Cantidad',
            operation: 'between',
        },
        {
            column: 'averageValue',
            input: 'range',
            label: 'Valor Promedio',
            operation: 'between',
        },
        {
            column: 'totalValue',
            input: 'range',
            label: 'Valor Total',
            operation: 'between',
        },
    ];

    // ----- Render
    return (
        <div className='container mt-5'>
            <h1 className='mb-5'>Reporte de Despachos por Órdenes de Trabajo</h1>

            <TableContainer
                columns={columns}
                fetchDataHandler={getIssuesByWorkOrderReport}
                updateTable={true}
                filters={filters}
                afterFilteringHandler={handleDataAfterFiltering}
                exportOptions={exportOptions}
            />

            {showWorkOrderDetailsTable && (
                <div className='my-5'>
                    <h3>Detalles para orden de trabajo: {currentWorkOrder.orderNumber}</h3>

                    <div className='d-flex justify-content-end'>
                        <AddButton className='btn btn-primary' onClick={() => setShowWorkOrderDetailsTable(false)}>
                            Ocultar detalles
                        </AddButton>
                    </div>

                    <TableContainer
                        columns={workOrderDetailsTableColumns}
                        fetchDataHandler={getWorkOrderIssuesDetails}
                        updateTable={updateTable}
                        filters={workOrderDetailsTableFilters}
                        pathVariables={currentWorkOrder}
                        exportOptions={exportDetailsOptions}
                        parentFilters={parentFilters}
                    />
                </div>
            )}
        </div>
    );
};

export default ReportIssueValueByWorkOrder;
